import React from "react";
import ContactForm from "./ContactForm";

const ContactSection = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 px-6 ">
        {/* Left Section */}
        <ContactForm/>

        {/* Right Section */}
        <div className="bg-gray-50 p-8 rounded-lg shadow-md">
          <h3 className="text-3xl lg:text-5xl font-semibold text-gray-800 mb-8 -mt-7 noto pt-4">
            Contact us
          </h3>
          <p className="text-lg text-gray-600 mb-4">
            <strong>By phone:</strong> <br /> +91-1140196111/222/333 <br />  +971 58 105 7002
          </p>
          <p className="text-lg text-gray-600 mb-4">
            <strong>By email:</strong>{" "} <br />
            <a
              href="mailto:enquiries@applicationuni.org"
              className="text-gray-900 hover:underline"
            >
              info@applicationuni.com
            </a>
          </p>
          <div className="flex space-x-4 text-gray-500 mb-10 mt-10 ">
            {/* Social Icons */}
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-blue-100"
            >
              <i className="fab fa-tiktok"></i>
            </a>
            <a
              href="https://www.facebook.com/besteducationaltours"
              className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-blue-100"
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/applicationuni?igsh=NGd2djhuaGJoZTM3"
              className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-blue-100"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-blue-100"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/86469217/admin/dashboard/"
              className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-blue-100"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
          <div>
            <p className="text-lg text-gray-600 mb-4">
              <strong>Book a meeting:</strong> <br /> with our Programme Consultant for
              1:1 support on your course choice.
            </p>
            <a
              href="#"
              className="inline-block py-3 px-6 bg-black text-white font-semibold rounded-lg hover:bg-blue-700 transition"
              onClick={() => window.open("https://calendly.com/applicationuni", "_blank")}
            >
              Book Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
